import {
    Icon16Block,
    Icon16ChevronOutline,
    Icon16CopyOutline,
    Icon16FavoriteOutline,
    Icon16UploadOutline,
    Icon20Hearts2Outline,
    Icon24SmileAddOutline,
} from '@vkontakte/icons';
import { ReactComponent as IconUnlimitedAutoupload } from 'img/icons/unlimited-autoupload-16.svg';
import React from 'react';
import { type FeatureItem, FeatureIDs } from 'reactApp/sections/QuotaLanding/MultiTariffsListMobile/Features/Features.types';

export const unlimitedAutouploadItem: FeatureItem = {
    id: FeatureIDs.unlim,
    text: 'Безлимит для фото с телефона',
    type: 'highlighted',
    iconBefore: <IconUnlimitedAutoupload />,
    iconAfter: <Icon16ChevronOutline />,
};

export const noadsItem: FeatureItem = {
    id: FeatureIDs.noads,
    text: 'Без рекламы в Почте и Облаке',
    type: 'normal',
    iconBefore: <Icon16Block />,
};

export const familyItem: FeatureItem = {
    id: FeatureIDs.family,
    text: 'Добавление ещё 3 участников',
    type: 'normal',
    iconBefore: <Icon24SmileAddOutline width={16} height={16} />,
};

export const familyAlbumsItem: FeatureItem = {
    id: FeatureIDs.familyAlbums,
    text: 'Семейные папки и альбомы',
    type: 'highlighted',
    iconBefore: <Icon20Hearts2Outline width={16} height={16} />,
};

export const uploadItem: FeatureItem = {
    id: FeatureIDs.upload,
    text: 'Загрузка файлов до 100 ГБ',
    type: 'normal',
    iconBefore: <Icon16UploadOutline />,
};

export const othersItem: FeatureItem = {
    id: FeatureIDs.others,
    text: (
        <>
            И другие <span>возможности</span>
        </>
    ),
    type: 'normal',
    iconBefore: <Icon16FavoriteOutline />,
};

export const duplicatesItem: FeatureItem = {
    id: FeatureIDs.duplicates,
    text: 'Удаление дубликатов',
    type: 'normal',
    iconBefore: <Icon16CopyOutline />,
};
